export default __webpack_public_path__ + "static/13-cb24592357e9ad89485a9aed69080411.webp";